// src/routes/PrivateRoutes.tsx
import React, { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import PrivateRoute from "./PrivateRouteWrapper";
import AppLayout from "../layouts/AppLayout";
import { useAppSelector } from "@redux/hooks";

// Private views
import Playground from "../playground/Playground";
// Routes for each team
import { ctxReflectorRoutes } from "../ctxReflector/routes";
import { kontrolEdgeRoutes } from "../kontrolEdge/routes";
import { settingsRoutes } from "../settings/routes";
import StatusPage from "ctxReflector/components/Status/StatusPage";
import { ctxReflectorV2Routes } from "../ctxReflectorV2/routes";

const ProductRedirect: React.FC = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const userProfile = useAppSelector((state) => state.userProfile);
	const hasKontrol = userProfile.ProductList.some(
		(product) => product.id === 2
	);
	const hasReflector = userProfile.ProductList.some(
		(product) => product.id === 1
	);

	useEffect(() => {
		// Only redirect if we're on the root path and the user has Kontrol but not Reflector
		if (location.pathname === "/" && hasKontrol && !hasReflector) {
			navigate("/kontrol");
		}
	}, [location.pathname, hasKontrol, hasReflector, navigate]);

	return null;
};

export function PrivateRoutes() {
	return (
		<>
			{/* <IntercomProvider /> */}
			<ProductRedirect />
			<Routes>
				<Route
					element={
						// 1) Check the token in PrivateRouteWrapper
						// 2) If valid, render the global layout
						<PrivateRoute>
							<AppLayout />
						</PrivateRoute>
					}
				>
					{/* Within the layout, define the main private routes */}
					<Route index path="/" element={<StatusPage />} />
					<Route path="playground" element={<Playground />} />

					{/* Inject the routes defined by each team */}
					{ctxReflectorRoutes}
					{ctxReflectorV2Routes}
					{kontrolEdgeRoutes}
					{settingsRoutes}
				</Route>
			</Routes>
		</>
	);
}
